/** @jsx jsx */

import { useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { Text } from '@chameleoncreator/creator-ui';
import 'services/ie11closestPolyfill';
import bulletStyles from './bulletStyles';

const ReadOnlyText = ({
  content,
  className,
  useBackgroundControls,
  borderRadius,
  backgroundColor,
  bulletColor,
  liTextColor,
  linkColors,
}) => {
  //
  const readOnlyText = useRef(null);

  let padding;

  if (useBackgroundControls || backgroundColor) {
    padding = `${12.5 + borderRadius}px ${10 + borderRadius}px`;
  }

  if (!!borderRadius) {
    padding = borderRadius * 3;
  }

  return (
    <Text
      ref={readOnlyText}
      className={`chameleon-text${className ? ` ${className}` : ''}`}
      as="div"
      css={css`
        a:link {
          color: ${linkColors.link} !important;
        }

        a:visited {
          color: ${linkColors.visited} !important;
        }

        a:hover {
          color: ${linkColors.hover} !important;
        }

        a:focus-visible {
          color: ${linkColors.focus} !important;

          outline-offset: 2px !important;
          outline: 1px solid ${linkColors.focus} !important;
          text-decoration: none !important;
        }

        a:active {
          color: ${linkColors.active} !important;
        }

        ${bulletStyles(bulletColor, liTextColor)}
      `}
      style={{
        ...((useBackgroundControls || backgroundColor) && {
          borderRadius,
          background: backgroundColor,
          padding,
        }),
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Text>
  );
};

export default ReadOnlyText;
